import { LoadingLayout } from 'components';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { useRepresentativeClientVersion } from '../hooks';
import { RepresentativeClientVersionView } from '../views/RepresentativeClientVersionView';

export const RepresentativeClientVersionContainer = () => {
  const {
    initialValues,
    loading,
    error,
    versions,
    breadcrumbsTitles,
    snapshot,
    fullName,
    snapshotLoading,
    versionId,
    onChangeVersion,
    onCloseVersionHistory,
  } = useRepresentativeClientVersion();

  if (error) {
    return <ErrorFallback />;
  }

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <RepresentativeClientVersionView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={[]}
      fullName={fullName}
      initialValues={initialValues}
      kycData={snapshot?.value.kyc}
      snapshotLoading={snapshotLoading}
      versionId={versionId}
      versions={versions ?? []}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  );
};
